module.exports = __webpack_public_path__ + "static/media/disconnected.9d4ba0ec.svg";